export const getLastSegmentFromUrl = (url: string): string =>
  url.substring(url.lastIndexOf('/') + 1);
